// MA19 합배송스케쥴 — React Query 훅 (TM-4166).
import { useQuery } from '@tanstack/react-query'
import type { UseQueryResult } from '@tanstack/react-query'
import { searchPairOrderSchedules } from './apis'
import { toRow } from './mapping'
import { PAIR_ORDER_SCHEDULE_MENU_CODE } from './consts'
import type { PairOrderScheduleRow, PairOrderScheduleSearchReq } from './types'

/**
 * 메뉴코드는 소문자로 둔다 — 탭을 닫을 때 `MenuOnSessionWrap.remove` 가 queryKey 에 든 소문자 메뉴코드로 캐시를 지운다.
 * `nonce` 는 같은 조건 [조회] 재클릭·저장 뒤 재조회를 새 요청으로 만든다.
 */
export const pairOrderScheduleQueryKeys = {
  all: [PAIR_ORDER_SCHEDULE_MENU_CODE, 'PAIR_ORDER_SCHEDULE'] as const,
  list: (params: PairOrderScheduleSearchReq | null, nonce: number) => [...pairOrderScheduleQueryKeys.all, 'list', params, nonce] as const,
}

/** 조회 — [조회]로 확정한 조건이 있을 때만 부른다. 실패 알럿은 전역 QueryCache 가 띄운다. */
export const useGetPairOrderScheduleList = (
  params: PairOrderScheduleSearchReq | null,
  nonce: number,
): UseQueryResult<PairOrderScheduleRow[], Error> =>
  useQuery({
    queryKey: pairOrderScheduleQueryKeys.list(params, nonce),
    queryFn: async () => {
      if (!params) return []
      const res = await searchPairOrderSchedules(params)
      return (res.data?.items ?? []).map(toRow)
    },
    enabled: !!params,
    staleTime: Infinity,
  })
